import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatButtonModule } from '@angular/material/button';
import { LearnMoreModalComponent } from './learn-more-modal/learn-more-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sms-info-banner',
  standalone: true,
  imports: [CommonModule, MatCardModule, GalaxyBadgeModule, MatButtonModule, TranslateModule],
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
})
export class InfoBannerComponent {
  @Input() title: string;
  @Input() imageURL: string;
  @Input() description: string;
  @Input() badgeText: string;
  @Input() badgeColor: 'red' | 'yellow' | 'green';

  constructor(private dialog: MatDialog) {}

  openLearnMoreModal(): void {
    this.dialog.open(LearnMoreModalComponent, { width: '600px' });
  }
}
